import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  PoButtonModule,
  PoContainerModule,
  PoPageModule,
  PoFieldModule,
  PoSelectOption,
  PoModalModule,
  PoModalComponent,
  PoLoadingModule,
} from '@po-ui/ng-components';
import { PartnerService } from '../../services/api/partner.service';
import { AuthService } from '../../services/auth/auth.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-partner-selection',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    PoPageModule,
    PoContainerModule,
    PoFieldModule,
    PoButtonModule,
    PoModalModule,
    PoLoadingModule
  ],
  templateUrl: './partner-selection.component.html',
  styleUrl: './partner-selection.component.scss',
})
export class PartnerSelectionComponent implements OnInit, OnDestroy {
  @ViewChild(PoModalComponent, { static: true }) poModal!: PoModalComponent;

  private subscription = new Subscription();
  selectedPartner: any
  partners: PoSelectOption[] = [];
  userName: string = ''
  emailToContactSupport = 'example@example.com.br'
  loadingData: boolean = true;

  constructor(
    private router: Router,
    private readonly authService: AuthService,
    private readonly partnerService: PartnerService,
  ) {}

  ngOnInit() {
    if (this.partnerService.hasSelectedPartner()) {
      this.router.navigate(['/']);
    }

    this.partnerService.fetchPartners().subscribe({
      next: (partners) => {
        if (partners && partners.length > 0) {
          this.partners = partners.map(p => ({
            label: p.name,
            value: p.id,
          }));
        } else {
          this.poModal.open()
        }
        this.loadingData = false;
      },
      error: (error) => {
        console.error('Erro ao buscar parceiros:', error);
        this.loadingData = false;
        this.poModal.open();
      },
      complete: () => {
        this.loadingData = false;
      }
    });

    this.authService.currentUser$.subscribe(user => {
      if (user && user.given_name) {
        this.userName = `${user.given_name} ${user.middle_name}`;
      } else {
        this.userName = 'Usuário';
      }
    })
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  handlePartner(event: Event) {
    this.selectedPartner = event
  }

  continueToHome() {
    if (this.selectedPartner) {
      this.partnerService.selectPartner(this.selectedPartner)
      this.router.navigate(['/']);
    }
  }

  contactSupport() {
    window.location.href = "https://totvs.com.br";
  }
}